var lastDayOfMonth = function (date) {
    return +moment(date).endOf('month').toISOString().substr(8, 2)
}

angular.module('SpidApp')

.factory('MonthStockLineChartGenerator', ['StockChartUtils', function (StockChartUtils) {
    var MonthStockLineChartGenerator = function (stockflowsHistory) {
    	stockflowsHistory = stockflowsHistory || {}
    	
    	var labels = []
    	var series = []
    	var datas  = []
    	var colors = []
    	
    	var today = moment()
        var startOfMonth = moment().startOf('month')
        var endOfMonth = moment()
        endOfMonth.set('date', lastDayOfMonth(today))
        
    	_.chain(stockflowsHistory).mapObject(function(stockflows) {
    		
    		series.push(stockflows[0].stockProduct.product.label);
    		colors.push(StockChartUtils.hashStringToColor(stockflows[0].stockProduct.product.label));
    		
    		var stockflowsOrderedByDay = _.chain(stockflows).groupBy(function (stockflow) {
                return moment(stockflow.updated_at).format('DD/MM/YYYY') // TODO: bad locale flow
            }).mapObject(function (stockflows) {
                var res = 0
                if (stockflows.length > 0) {
                    res = stockflows[0].current
                }
                return res
            }).value()
            
            var data = []
    		var curseur = moment(startOfMonth)
            var nDays = lastDayOfMonth(today)
            
            var dataTmp = 0;
            for (var i = 0 ; i < nDays ; i++) {
	            var key = curseur.format('DD/MM/YYYY')
	            
            	if (!stockflowsOrderedByDay[key] && stockflowsOrderedByDay[key] !== 0) {
            		data[i] = dataTmp
            	}
            	else {
            		data[i] = stockflowsOrderedByDay[key]
            	}
            	dataTmp = data[i]
	            curseur.add(1, 'day')
	        }
	        datas.push(data)
    	})
    	
    	var nDays = lastDayOfMonth(today)
        for(var i = 1 ; i <= nDays ; i++) {
            labels[i-1] = i + ''
        }
        
        this.labels  = labels
        this.series  = series
        this.datas	 = datas
        this.colours = colors
    }
    
    MonthStockLineChartGenerator.prototype.get = function () {
        return {
              series     : this.series
            , labels     : this.labels
            , datas      : this.datas
            , colours	 : this.colours
        }
    }
    
    return MonthStockLineChartGenerator
}])
